import { render, staticRenderFns } from "./IconSvgPinned.vue?vue&type=template&id=0345e3e2&scoped=true&"
import script from "./IconSvgPinned.vue?vue&type=script&lang=js&"
export * from "./IconSvgPinned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345e3e2",
  null
  
)

export default component.exports